/**
 * Stepper Component - Template
 * ============================
 */

export const STEPPER_TEMPLATE: string = `
<div class="ec-stepper" ng-class="$ctrl.getWrapperClasses()">
  <span ng-if="$ctrl.label || $ctrl.hasLabelSlot" ng-class="$ctrl.getLabelClasses()"><span ng-if="$ctrl.hasLabelSlot" ng-transclude="labelSlot"></span><span ng-if="!$ctrl.hasLabelSlot">{{ $ctrl.label }}</span></span>

  <div ng-class="$ctrl.getControlClasses()">
    <button
      type="button"
      ng-class="$ctrl.getMinusClasses()"
      ng-click="$ctrl.decrement()"
      ng-disabled="$ctrl.minusDisabled"
      ng-attr-aria-label="{{ $ctrl.ariaLabel ? ($ctrl.ariaLabel + ': disminuir') : 'Disminuir' }}"
    >
      <span ng-class="$ctrl.getIconClasses()" ng-bind-html="$ctrl.trustedMinus" aria-hidden="true"></span>
    </button>

    <span ng-class="$ctrl.getValueClasses()" aria-live="polite">{{ $ctrl.value }}</span>

    <button
      type="button"
      ng-class="$ctrl.getPlusClasses()"
      ng-click="$ctrl.increment()"
      ng-disabled="$ctrl.plusDisabled"
      ng-attr-aria-label="{{ $ctrl.ariaLabel ? ($ctrl.ariaLabel + ': aumentar') : 'Aumentar' }}"
    >
      <span ng-class="$ctrl.getIconClasses()" ng-bind-html="$ctrl.trustedPlus" aria-hidden="true"></span>
    </button>
  </div>
</div>
`;

export default STEPPER_TEMPLATE;
